<template>

    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4" :class="'row-cols-xl-' + maxPerRow">
        <div class="col" v-for="product in products">
            <product :product="product" :loading="loading" />
        </div>
    </div>

</template>


<script>
    import Product from '@/shared/Product';

    export default {
        props: {
            products: Array,
            maxPerRow: {
                default: 6,
            },
            loading: {
                default: false
            }
        },
        components: {
            Product,
        },
        data() {
            return {

            }
        }
    }
</script>